<template>
  <div>
    <v-snackbar v-model="active">
      {{ "Sucessfully Updated" }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="active = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      _active: 'groupDetails/getUpdated',
    }),
    active: {
      get() {
        return this._active;
      },
      set(val) {
        this._setActive(val);
      },
    },
  },
  methods: {
    ...mapMutations({
      _setActive: 'groupDetails/setUpdated',
    }),
  },
};
</script>
